import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

export const TableHead = forwardRef<
  HTMLTableCellElement,
  React.ThHTMLAttributes<HTMLTableCellElement>
>(({ className, ...props }, ref) => (
  <th
    ref={ref}
    className={twMerge(
      "bg-surface-container-high p-6 text-base font-medium text-neutral-variant-40 dark:bg-surface-container-high-dark dark:text-neutral-variant-80",
      className,
    )}
    {...props}
  />
));
TableHead.displayName = "TableHead";
